import { render, staticRenderFns } from "./QueueDetail.vue?vue&type=template&id=8c3ca1a2&scoped=true"
import script from "./QueueDetail.vue?vue&type=script&lang=js"
export * from "./QueueDetail.vue?vue&type=script&lang=js"
import style0 from "./QueueDetail.vue?vue&type=style&index=0&id=8c3ca1a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3ca1a2",
  null
  
)

export default component.exports